import { z } from 'zod';
import { paginationQuerySchema } from '../common/envelope.js';
export const listNotificationsQuerySchema = paginationQuerySchema.extend({
    unreadOnly: z.coerce.boolean().default(false),
});
export const notificationResponseSchema = z.object({
    id: z.string().uuid(),
    type: z.string(),
    title: z.string(),
    body: z.string().nullable(),
    payload: z.record(z.string(), z.unknown()),
    readAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=schemas.js.map